import styled from 'styled-components'

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
`
export default Row
